export default __webpack_public_path__ + "static/media/straight-couple.464135d0.png";